module.exports = __webpack_public_path__ + "static/media/github.f957afe4.png";